module.exports = __webpack_public_path__ + "img/62cb7b8.webp";